import {
  getCatalogoDePaises,
  getDias,
  getDocumentosDeRegularizacion,
  getDocumentosParaRemolques,
  getEstadosDelPadron,
  getMotivosMeritoDemerito,
  getRegimenCapital,
  getTiposDeCombustibles,
  getUsosDeMotocicletas,
  getUsosDeRemolques,
  getVersionesVehiculares,
  getProcedenciasDeVehiculos,
  getTiposDeDocumentosDeTraslaciones,
} from 'api/catalogos';
import { getAseguradoras } from 'api/catalogos/aseguradoras';
import { getMarcasDeMotocicletas } from 'api/catalogos/marcasDeMotocicletas';
import { getMarcasDeRemolques } from 'api/catalogos/marcasDeRemolques';
import { getTiposDePersonas } from 'api/catalogos/tipoDePersona';
import { getTiposZonaExclusivas } from 'api/catalogos/tipoDeZonasExclusivas';
import { getTiposDeCategoriasDeComercios } from 'api/catalogos/tiposDeCategoriasDeComerciosInformales';
import {
  getClasesDeAseo,
  getClavesZonificacion,
  getCorredoresDeValor,
  getEstatusDelPredio,
  getEtapasDePredios,
  getFactoresDeTraslado,
  getPavimentosDePredios,
  getPredioCaja,
  getRegimenesDePropiedad,
  getTipoDeDesarrollo,
  getTipoDePredio,
  getTipoDeTenencia,
  getTiposDeAseos,
  getTiposDeAvaluo,
  getTiposDeCuentasDePredios,
  getTiposDePrediosUrbanos,
  getTiposDeValuacion,
  getUnidadesDeMedidaDePredios,
  getUnidadesDeMedidaDeSuperficieDePredios,
  getUsosDePredio,
  getZonasDePredios,
  getZonasHomogeneas,
} from 'api/catastro';
import { getDepartamentos } from 'api/configuracion/departamentos';
import { getUnidadesDeRecaudacionPredios } from 'api/configuracion/unidadesDeRecaudacion';
import { getCiudadanoCaja } from 'api/cuentaunicasir/index';
import { getTiposDeConsiderados } from 'api/cuentaunicasir/tipoDeConsiderado';
import {
  getClasificacionesDeComercio,
  getEmpresaCaja,
  getRegimenFiscales,
  getScianCatalogo,
  getSectoresComerciales,
  getTiposDeContratosDePolicias,
  getTiposDeEmpresas,
  getTiposDeEstablecimientos,
  getTiposDeServiciosDePolicias,
} from 'api/empresas';
import { getCategoriasDeGiro } from 'api/empresas/categoriaDeGiroDeLicencia';
import { getClasesDeActividadesEmpresariales } from 'api/empresas/claseDeActividadEmpresarial';
import { getContribuyenteCaja } from 'api/empresas/contribuyentes';
import { getGirosComercioInformales } from 'api/empresas/giroDeComercioInformal';
import { getGirosLicencias } from 'api/empresas/giroDeLicencia';
import { getGirosMercados } from 'api/empresas/giroDeMercado';
import { getMercados } from 'api/empresas/mercado';
import { getTiposDeAlcoholes } from 'api/empresas/tiposDeAlcoholes';
import {
  getClasesDeVehiculos,
  getEstadosDeVehiculo,
  getServiciosDeVehiculo,
  getTiposDeVehiculos,
  getColoresVehiculos,
  getMarcasDeVehiculos,
  getMarcasDeVehiculosSinPaginar,
} from 'api/recaudacion';
import { getClasesDeMultas } from 'api/recaudacion/claseDeMulta';
import { getLineasDeVehiculos, getLineasDeVehiculosSinPaginar } from 'api/recaudacion/lineasVehiculares';
import { getSectoresDeMultas } from 'api/recaudacion/sectorDeMulta';
import { getTiposDeObras } from 'api/recaudacion/tipoDeObras';
import { getTiposDeTenencias } from 'api/recaudacion/tiposDeTenencias';
import { getEstadosCiviles, getGeneros, getLadas } from 'api/usuarios';
import { getUsuarios } from 'api/usuarios/usuarios';
import { getGirosDeAlcoholes } from 'api/recaudacion/girosDeAlcoholes';
import { getZonasDeModulos } from 'api/empresas/zonasDeModulo';
import { getMercadosDeModulos } from 'api/empresas/mercadosDeModulos';
import { getPlazasDeMercados } from 'api/catalogos/plazasDeMercado';
import { getTiposDeMercado } from 'api/catalogos/tiposDeMercado';
import { getZonasDeMercados } from 'api/catalogos/zonasDeMercado';
import { getDependencias } from 'api/configuracion/dependencias';
import { getTramites } from 'api/tramites/tramites';
import { getCatalogoPeritosDePredio } from 'api/catastro/peritosDePredios';
import { getCatalogoNotariosDePredios } from 'api/catastro/notariosDePredios';
import getAllPages from 'utils/getAllPages';
import { padronesEnum } from '../enums';

const REPUVE = process.env.REACT_APP_ENV_NAME === 'repuve';

const gettersUsuarios = {
  Usuario: getUsuarios,
  Lada: getLadas,
  EstadoCivil: getEstadosCiviles,
  Genero: getGeneros,
};

const gettersCuentaUnica = {
  Ciudadano: getCiudadanoCaja,
  TipoDeConsiderado: getTiposDeConsiderados,
};

const gettersEmpresa = {
  Contribuyente: getContribuyenteCaja,
  Empresa: getEmpresaCaja,
  GiroDeLicencia: getGirosLicencias,
  CategoriaDeGiroDeLicencia: getCategoriasDeGiro,
  SectorComercial: getSectoresComerciales,
  ClasificacionDeComercio: getClasificacionesDeComercio,
  TipoDeEstablecimiento: getTiposDeEstablecimientos,
  ClaseDeActividadEmpresarial: getClasesDeActividadesEmpresariales,
  TipoDeAlcohol: getTiposDeAlcoholes,
  TipoDeServicioDePolicia: getTiposDeServiciosDePolicias,
  TipoDeContratoDePolicia: getTiposDeContratosDePolicias,
  GiroDeComercioInformal: getGirosComercioInformales,
  GiroDeMercado: getGirosMercados,
  Mercado: getMercados,
  TipoDeCategoriaDeComercioInformal: getTiposDeCategoriasDeComercios,
  RegimenFiscal: getRegimenFiscales,
  TipoDeEmpresa: getTiposDeEmpresas,
  ClaseEmpresarial: getScianCatalogo,
  ZonaDeModulo: getZonasDeModulos,
  MercadoDeModulo: getMercadosDeModulos,
  PlazaDeMercado: getPlazasDeMercados,
  TipoDeMercado: getTiposDeMercado,
  ZonaDeMercado: getZonasDeMercados,
};

const gettersRecaudacion = {
  ServicioDelVehiculo: getServiciosDeVehiculo,
  EstadoDelVehiculo: getEstadosDeVehiculo,
  TipoDeVehiculo: getTiposDeVehiculos,
  ClaseDelVehiculo: getClasesDeVehiculos,
  TipoDeTenenciaVehicular: getTiposDeTenencias,
  LineaVehicular: REPUVE ? getLineasDeVehiculosSinPaginar : getLineasDeVehiculos,
  Marca: REPUVE ? getMarcasDeVehiculosSinPaginar : getMarcasDeVehiculos,
  TipoDeObra: getTiposDeObras,
  SectorDeMulta: getSectoresDeMultas,
  ClaseDeMulta: getClasesDeMultas,
  ProcedenciaDeVehiculo: getProcedenciasDeVehiculos,
  GiroDeAlcohol: getGirosDeAlcoholes,
};

const gettersCatalogos = {
  ClaveDeDocumentoDeRegularizacion: getDocumentosDeRegularizacion,
  VersionVehicular: getVersionesVehiculares,
  CatalogoDeColorVehicular: getColoresVehiculos,
  TipoDeCombustibleVehicular: getTiposDeCombustibles,
  CatalogoDePais: getCatalogoDePaises,
  UsoDeLaMotocicleta: getUsosDeMotocicletas,
  RegimenCapital: getRegimenCapital,
  TipoDePersona: getTiposDePersonas,
  EstadoDelPadron: getEstadosDelPadron,
  MarcaDeMotocicleta: getMarcasDeMotocicletas,
  MarcaDeRemolque: getMarcasDeRemolques,
  UsoDelRemolque: getUsosDeRemolques,
  TramiteDelRemolque: getDocumentosParaRemolques,
  CatalogoDeDias: getDias,
  TipoDeZonaExclusiva: getTiposZonaExclusivas,
  Aseguradora: getAseguradoras,
  MotivoDeMeritoDemeritoTerreno: getMotivosMeritoDemerito,
  ClaveDeZonificacion: getClavesZonificacion,
  TipoDeDocumentoDeTraslacion: getTiposDeDocumentosDeTraslaciones,
  PavimentoDePredio: getPavimentosDePredios,
  TipoDePredioUrbano: getTiposDePrediosUrbanos,
  TipoDeAvaluo: getTiposDeAvaluo,
  EtapaDePredio: getEtapasDePredios,
};

const gettersCatastro = {
  TipoDePredio: getTipoDePredio,
  TipoDeDesarrolloDePredio: getTipoDeDesarrollo,
  TipoDeTenencia: getTipoDeTenencia,
  RegimenDePropiedad: getRegimenesDePropiedad,
  UsoDePredio: getUsosDePredio,
  CorredorDeValor: getCorredoresDeValor,
  ZonaHomogenea: getZonasHomogeneas,
  Predio: getPredioCaja,
  UnidadDeMedidaParaPredio: getUnidadesDeMedidaDePredios,
  UnidadDeMedidaDeSuperficieParaPredio: getUnidadesDeMedidaDeSuperficieDePredios,
  EstadoDelPredio: getEstatusDelPredio,
  ZonaDePredio: getZonasDePredios,
  ClaseDeAseo: getClasesDeAseo,
  TipoDeAseo: getTiposDeAseos,
  TipoDeValuacion: getTiposDeValuacion,
  FactorDeTraslado: getFactoresDeTraslado,
  TipoDeCuentaDePredio: getTiposDeCuentasDePredios,
};

const gettersConfiguracion = {
  UnidadDeRecaudacion: getUnidadesDeRecaudacionPredios,
  UnidadResponsable: getDepartamentos,
  UnidadOperativa: getDependencias,
};

const gettersTramites = {
  Tramite: getTramites,
};

export const gettersByPadronByProp = {
  [padronesEnum.PREDIO]: {
    notario_contribuyente: () => getAllPages(getCatalogoNotariosDePredios),
    perito_contribuyente: () => getAllPages(getCatalogoPeritosDePredio),
  },
};

export default {
  catalogos: gettersCatalogos,
  usuarios: gettersUsuarios,
  recaudacion: gettersRecaudacion,
  cuentaunicasir: gettersCuentaUnica,
  empresa: gettersEmpresa,
  catastro: gettersCatastro,
  configuracion: gettersConfiguracion,
  tramite: gettersTramites,
};
